

// import React from "react";
// import devImg from "../assets/onkar.webp"; // image path बरोबर ठेवा

// export default function Footer() {
//   return (
//     // <footer className="bg-gradient-to-r from-red-600 to-red-500 text-white py-14 mt-20 relative">

//     <footer className="bg-gradient-to-r from-[#7b1919] to-[#a32b2b] text-white py-14 mt-20 relative">

//       {/* Top Glow Line */}
//       <div className="absolute top-0 left-0 w-full h-[3px] bg-white/30 shadow-lg"></div>

//       <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">

//         {/* Brand Section */}
//         <div className="text-center">
//           <h2 className="text-2xl font-extrabold mb-4">LABTOUCH PATHOLOGY LAB</h2>
//           <p className="text-white/85 leading-relaxed max-w-md mx-auto">
//            Quality Diagnostics You Can Trust.. </p>
//         </div>

//         {/* Links Section */}
//         <div className="text-center">
//           <h3 className="font-semibold mb-4 text-lg uppercase tracking-wide">
//             Quick Links
//           </h3>
//           <ul className="space-y-2 max-w-xs mx-auto">
//             {[
//               ["Home", "#home"],
//               ["Services", "#services"],
//               ["Admin", "#doctors"],
//               ["Contact", "#contact"],
//             ].map(([text, link], i) => (
//               <li key={i}>
//                 <a
//                   href={link}
//                   className="hover:text-yellow-300 transition-colors duration-300"
//                 >
//                   {text}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Developer Card */}
//         <div className="flex flex-col items-center">
//           <img
//             src={devImg}
//             alt="Developer"
//             className="w-40 rounded-xl shadow-lg border-2 border-white/40"
//           />

//           {/* <h3 className="text-xl font-bold mt-4">ONKAR</h3> */}
//           {/* <p className="text-white/85 text-sm">Developer</p> */}

//           <div className="flex items-center gap-3 mt-3">
//             <p className="text-lg font-semibold tracking-wider"></p>
//             <a
//               href="https://wa.me/7499090649"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               {/* <img
//                 src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
//                 alt="WhatsApp"
//                 className="w-7"
//               /> */}
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Line */}
//       <div className="w-full bg-white/20 h-[1px] mt-8"></div>

//       <div className="text-center mt-4 text-white/85 text-sm">
//   © {new Date().getFullYear()} Labtouch Pathology Lab — All Rights Reserved.
// </div>

//     </footer>
//   );
// }

import React from "react";
import devImg from "../assets/onkar.webp";
import VisitorCounter from "./VisitorCounter";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[#7b1919] to-[#a32b2b] text-white py-14 mt-20 relative">

      {/* Top Glow Line */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-white/30 shadow-lg"></div>

      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* Brand Section */}
        <div className="text-center">
          <h2 className="text-2xl font-extrabold mb-4">LABTOUCH PATHOLOGY LAB</h2>
          <p className="text-white/85 leading-relaxed max-w-md mx-auto">
            Quality Diagnostics You Can Trust..
          </p>
        </div>

        {/* Links Section */}
        <div className="text-center">
          <h3 className="font-semibold mb-4 text-lg uppercase tracking-wide">
            Quick Links
          </h3>
          <ul className="space-y-2 max-w-xs mx-auto">
            {[
              ["Home", "#home"],
              ["Services", "#services"],
              ["Admin", "#doctors"],
              ["Contact", "#contact"],
            ].map(([text, link], i) => (
              <li key={i}>
                <a
                  href={link}
                  className="hover:text-yellow-300 transition-colors duration-300"
                >
                  {text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Developer Card */}
        <div className="flex flex-col items-center">
          <img
            src={devImg}
            alt="Developer"
            className="w-40 rounded-xl shadow-lg border-2 border-white/40"
          />

          <div className="flex items-center gap-3 mt-3">
            <a
              href="https://wa.me/7499090649"
              target="_blank"
              rel="noopener noreferrer"
            >
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="w-full bg-white/20 h-[1px] mt-8"></div>

      {/* Footer Text & Visitor Counter */}
      <div className="text-center mt-4 text-white/85 text-sm space-y-2">
        <div>© {new Date().getFullYear()} Labtouch Pathology Lab — All Rights Reserved.</div>

        {/* Visitor Counter */}
        <div className="mt-1 flex justify-center">
          <VisitorCounter />
        </div>
      </div>
    </footer>
  );
}
